import { useNotificationModal } from '@room-match/shared-ui-components';
import { useEffect, useState } from 'react';
import { AGENCY_TALENT_PERMISSIONS } from 'shared/constants/PERMISSIONS';
import { IAgencyTalentPermissionPayload } from 'shared/interfaces/IProfile';

export const useAgencyTalentPermission = (agency_talent_permissions: any, nonRepre: boolean) => {
  const [permission, setPermission] = useState(agency_talent_permissions);

  useEffect(() => {
    setPermission(agency_talent_permissions || null);
  }, [agency_talent_permissions]);

  const {
    handleOpen: notifOpen,
    isOpen: isNotifOpen,
    NotificationModal,
    handleSetMessage: notifMessage,
  } = useNotificationModal({
    type: 'warning',
  });

  const handleAgencyTalentPermissions = ({
    module = 'primary_image',
    callback = () => {},
    message = '',
    type,
    ctaText,
  }: IAgencyTalentPermissionPayload) => {
    const attr = permission;
    const key = AGENCY_TALENT_PERMISSIONS?.[module]?.key;
    const label = AGENCY_TALENT_PERMISSIONS?.[module]?.label || 'profile';
    const permitted = attr?.includes(key) || attr === null;

    if (permitted || nonRepre) {
      callback();
    } else {
      const msg =
        message ||
        `You are not allowed to modify your ${label}. Only your representative on this profile can update this information. Please contact your representative.`;
      notifOpen();
      notifMessage(type || 'Warning', msg, ctaText);
    }
  };
  return {
    NotificationModal,
    isNotifOpen,
    notifOpen,
    notifMessage,
    handleAgencyTalentPermissions,
  };
};
